import { stringUtils } from '@/app/core/utils';
import { getCurrentFeatureCode } from '@/app/core/auth';
import {
  JobProgressStatus,
  JobStatus as JobStatusEnum,
  ProductNameEnum,
} from '@ssar-app/domain';
import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Tooltip,
} from '@chakra-ui/react';
import { AiOutlineMore } from 'react-icons/ai/index.js';

interface JobStatusProps {
  status?: JobStatusEnum;
  externalMessage?: string;
  externalSystemRef?: string;
  actions?: string[];
  handleUpdate?: (action: string, externalSystemRef: string) => void;
}

export const JobStatus = (props: JobStatusProps) => {
  const { status, externalMessage, actions, handleUpdate, externalSystemRef } =
    props;
  const enumValues: string[] = Object.values(JobStatusEnum);
  const enumKeys: string[] = Object.keys(JobStatusEnum);
  const statusMapped =
    status &&
    enumValues.filter((value) =>
      value === JobStatusEnum.IN_PROGRESS.toString()
        ? status
            .toString()
            .toLowerCase()
            .includes(JobProgressStatus.PROGRESS.toLowerCase())
        : status.toString().toLowerCase().includes(value.toLowerCase()),
    )[0];
  const statusName = statusMapped
    ? statusMapped
    : JobStatusEnum.UNKNOWN.toString();
  const statusKey =
    getCurrentFeatureCode() === ProductNameEnum.AscendUSAA &&
    status &&
    statusMapped
      ? status.toString()
      : enumKeys[enumValues.indexOf(statusName)];
  const className = `job-status job-status-${statusName.toLowerCase()}`;

  return (
    <HStack>
      <Tooltip label={externalMessage || ''}>
        <Box className={className} w='full'>
          {stringUtils.titleCase(statusKey.replace(/_/g, ' '))}
        </Box>
      </Tooltip>
      {actions && (
        <Menu placement='bottom-end' colorScheme='blackAlpha'>
          <MenuButton bg='white' h={8}>
            <Icon
              as={AiOutlineMore}
              fontSize='xl'
              verticalAlign='middle'
              cursor='pointer'
            />
          </MenuButton>
          <MenuList>
            {actions.length > 0 && (
              <MenuGroup title='CHANGE STATUS'>
                {actions.map((action) => (
                  <MenuItem
                    key={action}
                    onClick={() => {
                      handleUpdate &&
                        handleUpdate(action, externalSystemRef || '');
                    }}
                  >
                    {action}
                  </MenuItem>
                ))}
              </MenuGroup>
            )}
            {actions.length === 0 && (
              <MenuGroup title='Status change not available' />
            )}
          </MenuList>
        </Menu>
      )}
    </HStack>
  );
};
